import React, { useState, useContext } from "react"
import { Dropdown } from "react-bootstrap"
import {
  FiEdit,
  FiMoreVertical,
  FiBarChart,
  FiUsers,
  FiArrowRight,
  FiThumbsUp,
  FiTrendingUp,
} from "react-icons/fi"
import UAI from "../UAI"
import { UsuarioContext } from "../Context/Usuario"
import { Navigate } from "react-router-dom"
import { LinkContainer } from "react-router-bootstrap"

const MenuCohorte = (props) => {
  const { usuario } = useContext(UsuarioContext)

  const [dropdownOpen, setDropdownOpen] = useState(false)

  const toggle = () => {
    setDropdownOpen(!dropdownOpen)
  }

  const handleClickHistorico = (event) => {
    event.stopPropagation()
    props.Historico(props.cohorte)
  }

  const handleClickEditarEnLinea = (event) => {
    console.log("Editar en línea")
    event.stopPropagation()
    if (props.cohortes && props.cohortes.length > 1) {
      console.log("Múltiples cohortes")
      props.editarEnLinea(props.cohortes)
    } else if (props.cohorte) {
      console.log("Un cohorte")
      props.editarEnLinea([props.cohorte.id])
    }
  }

  const handleClickEntrevistas = (event) => {
    event.stopPropagation()
    props.Entrevistas(props.cohorte)
  }

  const handleClickCampañas = (event) => {
    event.stopPropagation()
    props.Campañas(props.cohorte)
  }

  const urlmaestroprogramas = () => {
    let id = (props.cohorte.esborrador ? -1 : 1) * props.cohorte.id
    let url =
      "https://fin.uai.cl/Postgrado/admin/PostulaAdmin/Cohorte/AgregarCohorte?" +
      (props.cohorte.esborrador ? "Id" : "CohorteId") +
      "=" +
      id
    window.open(url)
  }

  const urlFormulario = () => {
    window.open(
      "https://mkg.uai.cl/postgrados-nuevo/" +
        UAI.nombresGradosFormularios[props.cohorte.gradoid].toLowerCase() +
        "/" +
        props.cohorte.nombrecorto +
        "/page/contact/debug"
    )
  }

  const urlFormularioFolleto = () => {
    window.open(
      "https://mkg.uai.cl/postgrados-nuevo/" +
        UAI.nombresGradosFormularios[props.cohorte.gradoid].toLowerCase() +
        "/" +
        props.cohorte.nombrecorto +
        "/page/brochure/debug"
    )
  }

  const urlPostulaciones = () => {
    window.open(
      UAI.wwwroot() +
        UAI.basename() +
        "/documentos-postulaciones/" +
        props.cohorte.id
    )
  }

  return (
    <Dropdown direction="left" className="menuCohorte">
      <Dropdown.Toggle>
        <FiMoreVertical />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {props.Entrevistas !== undefined && (
          <Dropdown.Item
            onClick={handleClickEntrevistas}
            disabled={!usuario.tienePermisoEntrevistas}
          >
            <FiUsers /> Entrevistas
          </Dropdown.Item>
        )}
        {props.editarEnLinea &&
          props.cohorte &&
          !props.cohorte.esborrador &&
          props.permisoEditarPagina && (
            <LinkContainer
              className="nav-link"
              to={"/cohorte/" + props.cohorte.id}
            >
              <Dropdown.Item>
                <FiEdit /> Editar
              </Dropdown.Item>
            </LinkContainer>
          )}
        {props.editarEnLinea &&
          props.cohortes &&
          props.cohortes.length > 1 &&
          props.permisoEditarPagina && (
            <Dropdown.Item onClick={handleClickEditarEnLinea}>
              <FiEdit /> Editar seleccionados
            </Dropdown.Item>
          )}
        {props.cohorte && usuario.tienePermisoEdicionPostula && (
          <Dropdown.Item onClick={urlmaestroprogramas}>
            <FiEdit /> Abrir en Postula Maestro de Programas
          </Dropdown.Item>
        )}
        {props.cohorte && !props.cohorte.esborrador && (
          <Dropdown.Item onClick={urlPostulaciones}>
            <FiEdit /> Postulaciones
          </Dropdown.Item>
        )}
        {props.Historico !== undefined && (
          <Dropdown.Item onClick={handleClickHistorico}>
            <FiBarChart /> Ver histórico
          </Dropdown.Item>
        )}
        {props.Historico !== undefined && false && (
          <Dropdown.Item onClick={handleClickCampañas}>
            <FiTrendingUp /> Ver funnel
          </Dropdown.Item>
        )}
        {props.cohorte &&
          !props.cohorte.esborrador &&
          props.cohorte.nombrecorto &&
          props.cohorte.nombrecorto.length > 3 && (
            <Dropdown.Item onClick={urlFormulario}>
              <FiThumbsUp /> Probar formulario y respuesta
            </Dropdown.Item>
          )}
        {props.cohorte &&
          !props.cohorte.esborrador &&
          props.cohorte.nombrecorto &&
          props.cohorte.nombrecorto.length > 3 && (
            <Dropdown.Item onClick={urlFormularioFolleto}>
              <FiThumbsUp /> Probar descarga folleto y respuesta
            </Dropdown.Item>
          )}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default MenuCohorte
